export default {
    data() {
        return {
            sectionLocationEventData: {},
            sectionString: '',
        }
    },
    computed: {},
    methods: {
        updateSectionEvent({ section, location }) {
            console.log('updateSectionEvent-location', location)
            console.log('updateSectionEvent-section', section)
            const section_name = section.name
            location = location || section.location || {}

            this.sectionLocationEventData = {
                section_name,
                location,
            }

            this.sectionString =
                !location.address1 && !location.address2
                    ? 'Click to Select Location'
                    : (section_name || '') +
                      ',' +
                      (location.address1 || '') +
                      ', ' +
                      (location.address2 || '')
        },
    },
}
